import { Component, HostListener, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/shared/services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EnvService } from 'src/app/shared/services/env.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-gift-checkout',
  templateUrl: './gift-checkout.component.html',
  styleUrls: ['./gift-checkout.component.less'],
  animations: [
    trigger('slideToggle', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('300ms ease-out', style({ height: '*', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ height: 0, opacity: 0 }))
      ])
    ])
  ]
})
export class GiftCheckoutComponent implements OnInit {
  openSections: { [key: string]: boolean } = {
    packages: true,       // first section open by default
    credit: false,
    personalize: false,
    payment: false
  };
  amount = '0';
  packagePrice = 0;
  merchandiseCredit = 0;

  packageForm: FormGroup;
  creditForm: FormGroup;
  personalizeForm: FormGroup;
  paymentForm: FormGroup;
  discountAvailable: boolean;
  discountData: any;
  promo = '';
  promoErr: string = '';
  promoDetails: any;
  subtotal: number;
  paymentId: any;
  giftCardId: string;
  totalAmount: number = 0;
  disableCtn: boolean;
  showCheckout: boolean = true;
  personalizeFormSubmitted: boolean;
  today = new Date();

  constructor(private fb: FormBuilder, private api: ApiService, private snackbar: MatSnackBar,
    public env: EnvService, private router: Router
  ) {
    this.getDiscountData();

    // Section 1: Package selection
    this.packageForm = this.fb.group({
      package: ['1', Validators.required],
      promo: ['']
    });

    // Section 2: Merchandise credit
    this.creditForm = this.fb.group({
      creditAmount: ['', [Validators.required, Validators.min(0)]]
    });

    // Section 3: Personalization
    this.personalizeForm = this.fb.group({
      recipientName: ['', Validators.required],
      recipientEmail: ['', [Validators.required, Validators.email]],
      note: [''],
      giverName: ['', Validators.required],
      giverEmail: ['', [Validators.required, Validators.email]],
      deliveryDate: ['', [Validators.required]]
    });
  }
minDateValidator(minDate: Date) {
  return (control: FormControl) => {
    if (!control.value) return null;

    const entered = new Date(control.value);
    const min = new Date(minDate.setHours(0, 0, 0, 0));

    return entered < min ? { minDate: true } : null;
  };
}

  isSticky = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isSticky = window.pageYOffset > 250;
  }

  ngOnInit(): void {
  }
  changeAmount() {
    const pkg = +this.packageForm.get('package')?.value;
    const multiply = this.discountData?.price_discount ? this.getDiscountAmount : this.discountData?.design_book_amount
    this.packagePrice = (multiply * pkg);
  }
  get getTotal(): number {
    this.totalAmount = (+this.packagePrice) + (+this.merchandiseCredit);
    return this.totalAmount;
  }
  getDiscountData() {
    this.api.getDiscountData().subscribe((res: any) => {
      if (res) {
        if (res.price_discount) {
          this.discountAvailable = true;
        }
        this.discountData = res;
        if (this.discountData.price_discount) {
          this.packagePrice = this.getDiscountAmount;
        } else {
          this.packagePrice = this.discountData.design_book_amount;
        }

      }
    })
  }

  get getDiscountAmount() {
    let discount = ((+this.discountData.design_book_amount) * (1 - ((+this.discountData.price_discount) / 100)));
    return (+discount);
  }
  applyPromo() {
    this.promo = this.packageForm.get('promo')?.value;
    if (this.promo) {
      this.promoErr = '';
      const data = {
        promo: this.promo ? this.promo.toUpperCase() : '',
        // type: 'gift'
      }
        this.api.stripeDesignPayment(data).subscribe((res: any) => {
      // this.desPayResp = res.payment_info;
      // this.amount = res.payment_info.amount / 100;
      this.promoErr = res.promo_details.error_msg;
    });
      // this.api.promoObserver$.next(this.promo);
      // this.subtotal = this.discountData.design_book_amount - this.promoDetails.total_discount

    }
  }
  removePromo() {
    this.promo = '';
    this.packageForm.get('promo')?.setValue('');
    this.api.promoObserver$.next('--Remove--');
  }

  getPromoErr(e) {
    this.promoDetails = null;
    if (e.error_msg) {
      this.promoErr = e.error_msg;
    } else if (e.length === 0) {
      this.promoDetails = null;
    } else {
      this.promoDetails = e;

      this.subtotal = e.finalAmount;
    }
  }
  openSection(section: string) {
    this.openSections[section] = !this.openSections[section];
  }

  goNext(nextSection: string, prevSection: string, form: FormGroup) {
    if (form.valid) {
      if (nextSection === 'payment') {
        this.generateGiftCards();
      } else {
        this.openSections[nextSection] = true;
        this.openSections[prevSection] = false;

      }
    } else {
      form.markAllAsTouched();
    }
  }
  getPaymentId(e) {
    this.paymentId = e;
  }

  generateGiftCards() {
    this.disableCtn = true;
    this.personalizeFormSubmitted = false;
    let user = JSON.parse(localStorage.getItem('user'));
    const data = {
      "sender_user_id": user ? user.id : null,
      "sender_email": this.personalizeForm.get('giverEmail')?.value,
      "sender_name": this.personalizeForm.get('giverName')?.value,
      "recipient_email": this.personalizeForm.get('recipientEmail')?.value,
      "recipient_name": this.personalizeForm.get('recipientName')?.value,
      "sender_message": this.personalizeForm.get('note')?.value,
      "delivery_date": this.personalizeForm.get('deliveryDate')?.value,
      "items": [
        { "design_package_sku": "FULL_ROOM_3D", "qty": +this.packageForm.get('package')?.value }
      ],
      "wallet_credit_cents": this.merchandiseCredit * 100,
      "payment_reference": this.paymentId
    }
    this.api.generateGiftCards(data).subscribe((res: any) => {
      if (res.status) {
        this.personalizeFormSubmitted = true;
        this.giftCardId = res.gift_card_id;
        this.totalAmount = (+this.packagePrice) + (+this.merchandiseCredit);
        this.openSections['payment'] = true;
        this.openSections['personalize'] = false;
        setTimeout(() => {
          this.disableCtn = false;
        }, 2000);

      } else {
        this.disableCtn = false;
        this.snackbar.open('Gift Card generation is failed, Please try again or contact administrator', 'x', { duration: 7000 });
      }
      console.log(res);
    }, err => {
      this.disableCtn = false;
      this.snackbar.open('Gift Card generation is failed, Please try again or contact administrator', 'x', { duration: 7000 });

    });
  }
  orderId: string;
  paymentType: string;
  execPayment(e) {
    if (e.status) {
      this.orderId = e.order_id;
      this.showCheckout = false;
      this.router.navigate([`/design/gift/order/${this.orderId}`]);
      // this.showCheckout = false;
      // const data ={
      //   gift_id : this.giftCardId,
      //   payment_reference : e.payment_id,
      // }
      // this.api.finalizeGiftPayment(data).subscribe(res=>{ 

      // });
    } else {
      this.snackbar.open('Finalize Payment failed, Please try again or contact administrator', 'x', { duration: 7000 });
    }
  }
}
